<lib-form-field-container
    #anchor
    [kind]="FormContainerKind.Chips"
    [isOptional]="isOptional"
    [hideErrors]="autocomplete ? autocomplete.panelOpen : false"
    (fieldClicked)="Clicked($event); $event.stopPropagation()"
    (containerClicked)="Blur()"
    (mousedown)="$event.preventDefault()">
    <ng-content
        label
        select="[label]"></ng-content>
    <ng-content
        supportingText
        select="[supportingText]"></ng-content>
    <ng-content
        prefixText
        select="[prefixText]"></ng-content>
    <ng-content
        suffixText
        select="[suffixText]"></ng-content>

    <ng-container readOnly>
        <div #providedReadOnly class="wrapper-content">
            <ng-content select="[readOnly]"></ng-content>
        </div>
        <div class="default-content">{{ formControl.value }}</div>
    </ng-container>

    <ng-content
        bottomMenu
        select="[bottomMenu]"></ng-content>

    @if (showQuickSelect && !isReadOnly) {
        <lib-menu-button
            menu
            [disabled]="isDisabled"
            [kind]="ButtonKind.Link">
            <ng-container
                label
                i18n="@@CommonQuickSelectLabel">
                Quick Select
            </ng-container>
            <lib-menu-item
                i18n-label="@@CommonQuickSelectClearLabel"
                label="Clear"
                [stopPropagation]="true"
                [qaTag]="qaTag + '-clear-all'"
                (clicked)="ClearAll()"></lib-menu-item>
            <lib-menu-item
                i18n-label="@@CommonQuickSelectSelectAllLabel"
                label="Select All"
                [stopPropagation]="true"
                [qaTag]="qaTag + '-select-all'"
                (clicked)="SelectAll()"></lib-menu-item>
        </lib-menu-button>
    }

    @if (!isLoading && !isReadOnly) {
        <div
          [style.width]="selectedItems && selectedItems.size > 0 ? 'calc(100% - 40px)' : '100%'">
            <mat-chip-grid
                #chipGrid
                [disabled]="isDisabled">
                @for (item of selectedItems; track item) {
                    <mat-chip-row
                        [editable]="false"
                        (removed)="Remove(item)"
                        (mousedown)="$event.stopPropagation()"
                        (click)="ChipSelected(item, $event)">
                        <span>
                            {{ item }}
                        </span>
                        <lib-icon-button
                        matChipRemove
                        [kind]="ButtonKind.NeutralTertiary"
                        [icon]="Icon.Common.Close"
                        [size]="ButtonSize.Small"></lib-icon-button>
                    </mat-chip-row>
                }
                <input
                    #input
                    [id]="formFieldID"
                                        [attr.aria-describedby]="formFieldID + '-description ' + formFieldID + '-error'"
                                                                                [attr.aria-label]="ariaLabel || null"
                                                                                [attr.aria-invalid]="formControl.isDirty && formControl.errors ? 'true' : null"
                                        [attr.aria-required]="formControl.isRequired"
                    [placeholder]="chipsPlaceholderText"
                    [formControl]="viewControl"
                    [matAutocomplete]="auto"
                    [matAutocompleteConnectedTo]="anchor?.origin!"
                    [matChipInputFor]="chipGrid"
                    [matChipInputSeparatorKeyCodes]="separatorKeyCodes"
                    [attr.data-sb-qa]="qaTag + '-input'"
                    (matChipInputTokenEnd)="Add($event)"
                    (change)="$event.stopPropagation()"
                    (blur)="Clear()" />
            </mat-chip-grid>

            <mat-autocomplete
                #auto="matAutocomplete"
                (opened)="PanelOpened()">
                @for (item of filteredItems | async; track item) {
                    <mat-option
                        [value]="item"
                        class="v3" (click)="Selected(item); $event.stopPropagation()">
                        <span
                            class="scss-chip-overlay"
                            >
                            @if (autocomplete.panelOpen) {
                                {{ item }}
                            }
                        </span>
                    </mat-option>
                }
            </mat-autocomplete>
        </div>
    }
    <ng-container suffixIcon>
        @if (formControl?.value!.length) {
            <lib-icon-button
                [icon]="Icon.Common.Close"
                [kind]="ButtonKind.FormField"
                [size]="ButtonSize.Large"
                [disabled]="isDisabled"
                matTooltip="Clear"
                i18n-matTooltip="@@CommonClearLabel"
                (clicked)="ClearAll()"></lib-icon-button>
        } @else {
            <lib-icon-button
                [kind]="ButtonKind.FormField"
                [size]="ButtonSize.Large"
                [disabled]="isDisabled"
                [icon]="autocomplete && autocomplete.panelOpen ? Icon.Common.CaretUp : Icon.Common.CaretDown"
                (clicked)="autocomplete && autocomplete.panelOpen ? autocomplete.closePanel() : autocomplete.openPanel()"></lib-icon-button>
        }
    </ng-container>
</lib-form-field-container>
